import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  FaWarehouse,
  FaSchool,
  FaStore,
  FaMap,
  FaGooglePlay,
  FaQuestion,
  FaShoppingBasket
} from 'react-icons/fa';
import { FiArrowLeft, FiMenu } from 'react-icons/fi';
import { standards } from '../../components';
import { setSidebarVisible } from '../../../support/store/SidebarReducer';
import './stylesBasketWithoutProducts.css';

function useBasketWithoutProducts() {
  const location = useLocation();
  const history = useHistory();
  const spaceNickname = location.pathname.split('/')[1];
  const dispatch = useDispatch();

  const handleMenuClick = () => dispatch(setSidebarVisible({ visible: true }));
  const handleBackClick = () => history.goBack();
  const handleGoToPlayStore = () => { window.location.href = 'https://play.google.com/store/apps/details?id=com.locall.app'; };
  const handleGoToMap = () => history.push('/map');

  return ({
    localStates: {
      spaceNickname,
    },
    eventHandlers: {
      handleGoToMap,
      handleGoToPlayStore,
      handleMenuClick,
      handleBackClick,
    },
  });
}

export default function BasketWithoutProducts() {
  const { localStates, eventHandlers } = useBasketWithoutProducts();
  return (
    <div className="container">
      <section className="banner">
        <section className="nav-container">
          <FiArrowLeft onClick={eventHandlers.handleBackClick} color="#000" size={32} style={{ cursor: 'pointer' }} />
          <FiMenu onClick={eventHandlers.handleMenuClick} color="#000" size={32} style={{ cursor: 'pointer' }} />
        </section>

        <h2>{`Você não tem nenhum produto em sua cesta.`}</h2>

        <div className="image">
          <div className="image-builds">
            <FaShoppingBasket className="small-build" size={80} color={standards.colors.red.medium} />
          </div>
        </div>
      </section>

      <section className="error-message">
        <div className="box-options">
          <div className="option">
            <p>Descubra outros espaços e conheça o que oferecem no mapa Locall ou crie o seu pelo aplicativo.</p>

            <button className="red-button" type="button" onClick={eventHandlers.handleGoToMap}>
              <FaMap size={22} strokeWidth="3" color="#FFF" />
              <h4>Mapa Locall</h4>
            </button>

            <button className="soft-button" type="button" onClick={eventHandlers.handleGoToPlayStore}>
              <FaGooglePlay size={22} strokeWidth="3" color="#999" />
              <h4>Baixar app</h4>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
